import { Http } from '../../utils/http'
import { Cookie } from '../../utils/cookie'
import { Api as Config } from '../../utils/config'

class Api {
    // 获取投票分享昵称
    public static getShareNick() {
        const url = this.host + '/votecenter/activities/share/nick' +
            `?user_token=${this.token}` +
            `&union_id=${this.unionId}`
        return Http.get(url)
    }

    private static host = Config().host
    private static token = Cookie.get()
    private static unionId = Cookie.get(Cookie.WECHATIDKEY)
}

export {
    Api
}


// WEBPACK FOOTER //
// ./src/components/activity_option_detail/api.ts